import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import FadeIn from "react-fade-in/lib/FadeIn";

function BannerHeroCaption({
  content,
  translationTexts,
  redirectHandler,
  onClickPlayerButton,
  showProps = {
    availableIn: false,
    maxRating: false,
  },
  isPlayNow = true,
  selectedContentHandler,
}) {
  const { play_in, play_now, available_in, go_to_site, go_to_path } =
    translationTexts ?? {};

  const checkRedirect = (entitlementTypes) => {
    return entitlementTypes.some((e) => e === "media");
  };

  return (
    <div className="bannerHeroCarouselCaption carousel-caption">
      <div className="bannerHeroInfo">
        <FadeIn>
          <div className="bannerHeroData">
            {showProps.maxRating &&
              content.relatedContent &&
              content.relatedContent.ratings && (
                <div className="ratingBadge">
                  {content.relatedContent.ratings.map((rating) => {
                    return rating;
                  })}
                </div>
              )}
            {showProps.availableIn &&
              content.relatedContent &&
              content.relatedContent.networks && (
                <div className="networkBadge">{`${available_in}: ${content.relatedContent.networks.map(
                  (network) => {
                    return network.name;
                  }
                )}`}</div>
              )}
          </div>
          <div className="bannerHeroTitle">
            {content.title && <h2>{content.title}</h2>}
          </div>
          {(content.externalUrl ||
            content.sectionUrl ||
            (content.relatedContent &&
              content.relatedContent.entitlementTypes &&
              checkRedirect(content.relatedContent.entitlementTypes)) ||
            content?.relatedContent?.networks) && (
            <div className="bannerHeroActions">
              {content.externalUrl ? (
                <Button
                  className="play"
                  onClick={() =>
                    redirectHandler(
                      content.externalUrl,
                      "externalUrl",
                      content.externalUrlTarget
                    )
                  }
                >
                  <span>{go_to_site}</span>
                </Button>
              ) : (
                content.sectionUrl && (
                  <Button
                    className="play"
                    onClick={() =>
                      redirectHandler(content.sectionUrl, "sectionUrl")
                    }
                  >
                    <span>{`${go_to_path} ${
                      content.sectionName || "la sección"
                    }`}</span>
                  </Button>
                )
              )}

              {content.relatedContent &&
              content.relatedContent.entitlementTypes &&
              checkRedirect(content.relatedContent.entitlementTypes) ? (
                <Button
                  className="play"
                  onClick={() => selectedContentHandler(content.relatedContent)}
                >
                  <i className="bi bi-play-fill"></i>
                  <span>{play_now}</span>
                </Button>
              ) : (
                content.relatedContent?.networks && (
                  <Button
                    className="play"
                    onClick={() =>
                      selectedContentHandler(content.relatedContent)
                    }
                  >
                    {!isPlayNow && (
                      <span>{`${play_in}: ${content.relatedContent.networks.map(
                        (network) => network.name
                      )}`}</span>
                    )}
                    {isPlayNow && (
                      <>
                        <i className="bi bi-play-fill"></i>
                        <span>{play_now}</span>
                      </>
                    )}
                  </Button>
                )
              )}
            </div>
          )}
        </FadeIn>
      </div>
    </div>
  );
}

export default BannerHeroCaption;
